import {
  ACCESS_TOKEN,
  ACCESS_TOKEN_MAX_AGE,
  REFRESH_TOKEN,
  REFRESH_TOKEN_MAX_AGE,
} from '@/shared/constants'
import { notifyAuthSessionChange } from '@/shared/lib/auth-session-sync'
import { deleteCookie, getCookie, setCookie } from '@/shared/lib/cookies'

// HttpOnly is omitted: tokens are set client-side so getAccessToken/setAuthTokens
// can attach Bearer headers without backend Set-Cookie changes.

export function getAccessToken(): string | null {
  return getCookie(ACCESS_TOKEN)
}

export function getRefreshToken(): string | null {
  return getCookie(REFRESH_TOKEN)
}

export function setAuthTokens(accessToken: string, refreshToken: string): void {
  setCookie(ACCESS_TOKEN, accessToken, ACCESS_TOKEN_MAX_AGE)
  setCookie(REFRESH_TOKEN, refreshToken, REFRESH_TOKEN_MAX_AGE)
  notifyAuthSessionChange('tokens-set')
}

export function clearAuthTokens(): void {
  const hadTokens =
    getCookie(ACCESS_TOKEN) !== null || getCookie(REFRESH_TOKEN) !== null

  if (!hadTokens) {
    return
  }

  deleteCookie(ACCESS_TOKEN)
  deleteCookie(REFRESH_TOKEN)
  notifyAuthSessionChange('tokens-cleared')
}
